import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { LoginPage as GPLoginPage } from '@thegpvc/ui';
import { useAuth } from '../hooks/useAuth';

export function Login() {
  const { isAuthenticated, isLoading } = useAuth();
  const [searchParams] = useSearchParams();
  const [loggingIn, setLoggingIn] = useState(false);

  // Sanitize redirect_uri to prevent open redirect attacks
  // Allow: relative paths, localhost URLs (for the CLI localhost-callback flow).
  // The legacy paste-a-JWT "manual" flow was removed (#827); remote CLI setup
  // now uses the device-code grant (/cli/device/*) and never routes through here.
  const rawRedirect = searchParams.get('redirect_uri') || '/';
  const isRelative = rawRedirect.startsWith('/');
  const isLocalhost = rawRedirect.startsWith('http://localhost:') || rawRedirect.startsWith('http://127.0.0.1:');
  const isCLIFlow = isLocalhost;
  const redirectUri = (isRelative || isCLIFlow) ? rawRedirect : '/';

  // If already authenticated, redirect to the intended destination
  // For CLI flow, redirect to /cli-callback to issue token
  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      if (isCLIFlow) {
        window.location.href = `/cli-callback?redirect_uri=${encodeURIComponent(redirectUri)}`;
      } else {
        window.location.href = redirectUri;
      }
    }
  }, [isAuthenticated, isLoading, redirectUri, isCLIFlow]);

  const handleLogin = () => {
    setLoggingIn(true);
    const isDev = import.meta.env.DEV;
    const apiBase = isDev ? 'http://localhost:9080' : '';

    let oauthRedirect: string;
    if (isCLIFlow) {
      // CLI flow: OAuth redirects to /cli-callback which issues token
      // In dev, use absolute URL so OAuth redirects through Vite (not directly to backend)
      const cliCallback = `/cli-callback?redirect_uri=${encodeURIComponent(redirectUri)}`;
      oauthRedirect = isDev ? `http://localhost:5174${cliCallback}` : cliCallback;
    } else if (isDev) {
      // Dev mode: redirect back to Vite dev server
      oauthRedirect = `http://localhost:5174${redirectUri}`;
    } else {
      // Production web flow: redirect back to this app
      oauthRedirect = redirectUri;
    }

    window.location.href = `${apiBase}/api/auth/login?provider=google&redirect_uri=${encodeURIComponent(oauthRedirect)}`;
  };

  if (isLoading || isAuthenticated) {
    return (
      <>
        <title>Dixie :: Login</title>
        <GPLoginPage title="Dixie" onLogin={() => {}} loading />
      </>
    );
  }

  return (
    <>
      <title>Dixie :: Login</title>
      <GPLoginPage
        title="Dixie"
        subtitle="Claude Code Session Analytics"
        onLogin={handleLogin}
        loading={loggingIn}
        helperText="Sign in with your Google Workspace account"
      />
    </>
  );
}
